var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _g, _path8, _path9, _mask2, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 183,
    viewBox: "0 0 150 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 89.4883H0V178.054H150V89.4883Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 168.83H0V182.669H150V168.83Z",
    fill: "#B0E298"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.37 93.1797H5.09259C25 95.9474 67.3148 101.483 77.3148 101.483C87.3148 101.483 126.852 95.9474 145.37 93.1797Z",
    fill: "#E4E4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145 101H5V174H145V101Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.37 174.364H4.62964V101.242H19.3798C19.9944 104.754 20.9777 107.175 21.5923 108.628C39.0466 148.224 130.374 112.503 144.633 149.071C145.002 150.161 145.247 166.009 145.37 166.493C145.37 169.157 145.37 171.821 145.37 174.364Z",
    fill: "#54BCE3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55556 100H144.444L145.37 100.923H4.62964L5.55556 100Z",
    fill: "#E4E4E4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.296 89.4891H3.70367V88.6818C3.70367 87.0674 5.05236 85.7988 6.76886 85.7988H143.108C144.825 85.7988 146.174 87.0674 146.174 88.6818V89.4891H146.296Z",
    fill: "#BEBEBE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 119,
    width: 39,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 119.768,
    width: 39,
    height: 21.96,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2592 119.768H20.3704V142.726H59.2592V119.768Z",
    fill: "#4873E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3704,
    y: 119.768,
    width: 38.8889,
    height: 0.918327,
    fill: "#254FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3704 142.727L20.3704 119.769L21.0295 119.769L21.0295 141.808L20.3704 142.727Z",
    fill: "#254FBB"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.6109 120.766L21 141.727H36.2326L60 120.766H44.6109Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.5408 121.049L40.0729 140.533H43.0806L64.8147 121.049H62.5408Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 119,
    width: 39,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 119.768,
    width: 39,
    height: 21.96,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 120.236H78.7037V141.727H118V120.236Z",
    fill: "#4873E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.7037,
    y: 120.236,
    width: 39.2963,
    height: 0.85965,
    fill: "#254FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7037 141.727L78.7037 120.235L79.3698 120.235L79.3698 140.867L78.7037 141.727Z",
    fill: "#254FBB"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M102.716 121.049L79.4571 140.533H94.4624L117.875 121.049H102.716Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.874 121.049L98.4063 140.533H101.414L123.148 121.049H120.874Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0001 120.683C61.0001 120.177 61.4105 119.768 61.9167 119.768H71.0834C71.5897 119.768 72.0001 120.177 72.0001 120.683V129.833C72.0001 130.338 71.5897 130.748 71.0834 130.748H61.9167C61.4105 130.748 61.0001 130.338 61.0001 129.833V120.683Z",
    fill: "#FAAC48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 130.748C71.2239 130.748 71 130.543 71 130.291L71 120.226C71 119.973 71.2239 119.768 71.5 119.768C71.7761 119.768 72 119.973 72 120.226L72 130.291C72 130.543 71.7761 130.748 71.5 130.748Z",
    fill: "#DD871A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0001 120.225C61.0001 119.972 61.2239 119.768 61.5001 119.768C61.7762 119.768 62.0001 119.972 62.0001 120.225V130.29C62.0001 130.543 61.7762 130.748 61.5001 130.748C61.2239 130.748 61.0001 130.543 61.0001 130.29V120.225Z",
    fill: "#FFD5A0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5417 119.768C71.673 119.768 71.7914 119.828 71.875 119.924C71.5 120.267 71.5 120.267 71.5 120.267C71.5 120.267 71.5 120.267 71 120.766L61.4584 120.766C61.2052 120.766 61 120.542 61 120.267C61 119.991 61.2052 119.768 61.4584 119.768L71.5417 119.768Z",
    fill: "#FFD5A0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4583 130.748C61.3269 130.748 61.2085 130.688 61.125 130.592C61.5 130.249 61.4999 130.249 61.4999 130.249C61.4999 130.249 61.4999 130.249 61.9999 129.75L71.5416 129.75C71.7947 129.75 71.9999 129.973 71.9999 130.249C71.9999 130.525 71.7947 130.748 71.5416 130.748L61.4583 130.748Z",
    fill: "#DD871A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8333 126.016L66.5476 122.514V124.501L62.8333 128.004V126.016ZM70.1666 126.016L66.5476 122.514V124.501L70.1666 128.004V126.016Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120 120.683C120 120.177 120.41 119.768 120.917 119.768H130.083C130.59 119.768 131 120.177 131 120.683V129.833C131 130.338 130.59 130.748 130.083 130.748H120.917C120.41 130.748 120 130.338 120 129.833V120.683Z",
    fill: "#FAAC48"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 130.748C130.224 130.748 130 130.543 130 130.291L130 120.226C130 119.973 130.224 119.768 130.5 119.768C130.776 119.768 131 119.973 131 120.226L131 130.291C131 130.543 130.776 130.748 130.5 130.748Z",
    fill: "#DD871A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120 120.225C120 119.972 120.224 119.768 120.5 119.768C120.776 119.768 121 119.972 121 120.225V130.29C121 130.543 120.776 130.748 120.5 130.748C120.224 130.748 120 130.543 120 130.29V120.225Z",
    fill: "#FFD5A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.542 119.768C130.673 119.768 130.791 119.828 130.875 119.924C130.5 120.267 130.5 120.267 130.5 120.267C130.5 120.267 130.5 120.267 130 120.766L120.458 120.766C120.205 120.766 120 120.542 120 120.267C120 119.991 120.205 119.768 120.458 119.768L130.542 119.768Z",
    fill: "#FFD5A0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.458 130.748C120.327 130.748 120.209 130.688 120.125 130.592C120.5 130.249 120.5 130.249 120.5 130.249C120.5 130.249 120.5 130.249 121 129.75L130.542 129.75C130.795 129.75 131 129.973 131 130.249C131 130.525 130.795 130.748 130.542 130.748L120.458 130.748Z",
    fill: "#DD871A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.833 126.016L125.548 122.514V124.501L121.833 128.004V126.016ZM129.167 126.016L125.548 122.514V124.501L129.167 128.004V126.016Z",
    fill: "#333333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0001 131.661C61.0001 131.156 61.4105 130.746 61.9167 130.746H71.0834C71.5897 130.746 72.0001 131.156 72.0001 131.661V140.811C72.0001 141.316 71.5897 141.726 71.0834 141.726H61.9167C61.4105 141.726 61.0001 141.316 61.0001 140.811V131.661Z",
    fill: "#FAAC48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 141.727C71.2239 141.727 71 141.522 71 141.269L71 131.204C71 130.951 71.2239 130.747 71.5 130.747C71.7761 130.747 72 130.951 72 131.204L72 141.269C72 141.522 71.7761 141.727 71.5 141.727Z",
    fill: "#DD871A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0001 131.204C61.0001 130.951 61.2239 130.746 61.5001 130.746C61.7762 130.746 62.0001 130.951 62.0001 131.204V141.269C62.0001 141.521 61.7762 141.726 61.5001 141.726C61.2239 141.726 61.0001 141.521 61.0001 141.269V131.204Z",
    fill: "#FFD5A0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5417 130.746C71.673 130.746 71.7914 130.806 71.875 130.903C71.5 131.245 71.5 131.245 71.5 131.245C71.5 131.245 71.5 131.245 71 131.744L61.4584 131.744C61.2052 131.744 61 131.521 61 131.245C61 130.97 61.2052 130.746 61.4584 130.746L71.5417 130.746Z",
    fill: "#FFD5A0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4583 141.727C61.3269 141.727 61.2085 141.666 61.125 141.57C61.5 141.227 61.4999 141.227 61.4999 141.227C61.4999 141.227 61.4999 141.227 61.9999 140.728L71.5416 140.728C71.7947 140.728 71.9999 140.952 71.9999 141.227C71.9999 141.503 71.7947 141.727 71.5416 141.727L61.4583 141.727Z",
    fill: "#DD871A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1666 135.478L66.4522 138.98L66.4522 136.993L70.1666 133.49L70.1666 135.478ZM62.8332 135.478L66.4522 138.98L66.4522 136.993L62.8332 133.49L62.8332 135.478Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M120 131.661C120 131.156 120.41 130.746 120.917 130.746H130.083C130.59 130.746 131 131.156 131 131.661V140.811C131 141.316 130.59 141.726 130.083 141.726H120.917C120.41 141.726 120 141.316 120 140.811V131.661Z",
    fill: "#FAAC48"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M130.5 141.727C130.224 141.727 130 141.522 130 141.269L130 131.204C130 130.951 130.224 130.747 130.5 130.747C130.776 130.747 131 130.951 131 131.204L131 141.269C131 141.522 130.776 141.727 130.5 141.727Z",
    fill: "#DD871A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M120 131.204C120 130.951 120.224 130.746 120.5 130.746C120.776 130.746 121 130.951 121 131.204V141.269C121 141.521 120.776 141.726 120.5 141.726C120.224 141.726 120 141.521 120 141.269V131.204Z",
    fill: "#FFD5A0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M130.542 130.746C130.673 130.746 130.791 130.806 130.875 130.903C130.5 131.245 130.5 131.245 130.5 131.245C130.5 131.245 130.5 131.245 130 131.744L120.458 131.744C120.205 131.744 120 131.521 120 131.245C120 130.97 120.205 130.746 120.458 130.746L130.542 130.746Z",
    fill: "#FFD5A0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M120.458 141.727C120.327 141.727 120.209 141.666 120.125 141.57C120.5 141.227 120.5 141.227 120.5 141.227C120.5 141.227 120.5 141.227 121 140.728L130.542 140.728C130.795 140.728 131 140.952 131 141.227C131 141.503 130.795 141.727 130.542 141.727L120.458 141.727Z",
    fill: "#DD871A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.167 135.478L125.452 138.98L125.452 136.993L129.167 133.49L129.167 135.478ZM121.833 135.478L125.452 138.98L125.452 136.993L121.833 133.49L121.833 135.478Z",
    fill: "#333333"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M150 89.4588V83.4512C150 82.9185 149.553 82.4746 149.016 82.4746H0.9839C0.447228 82.4746 0 82.9185 0 83.4512V89.4884H150V89.4588Z",
    fill: "#E4E4E4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M150 84.2207H0V86.2923H150V84.2207Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M147.257 77.1484H2.74299C1.22242 77.1484 0 78.3618 0 79.8711V85.2573H150V79.8711C150 78.3914 148.778 77.1484 147.257 77.1484Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.164 75.7428C43.9681 77.1503 43.2618 78.9878 43.2618 80.6695H37.8951C37.8951 77.6162 39.1268 74.5854 41.0615 72.3085C42.9988 70.0283 45.8574 68.2695 49.2248 68.2695H100.745C104.107 68.2695 106.966 70.0158 108.907 72.2953C110.845 74.5716 112.075 77.6037 112.075 80.6695H106.708C106.708 78.9706 106.001 77.1345 104.808 75.7337C103.618 74.3362 102.154 73.5965 100.745 73.5965H49.2248C47.8218 73.5965 46.3572 74.3384 45.164 75.7428Z",
    fill: "#54BCE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBath);
export default __webpack_public_path__ + "static/media/Water Bath.ff5d2857465b7a0b206385a189f37669.svg";
export { ForwardRef as ReactComponent };